import { render, staticRenderFns } from "./modalMainAlert.vue?vue&type=template&id=482570e9&scoped=true"
import script from "./modalMainAlert.vue?vue&type=script&lang=js"
export * from "./modalMainAlert.vue?vue&type=script&lang=js"
import style0 from "./modalMainAlert.vue?vue&type=style&index=0&id=482570e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482570e9",
  null
  
)

export default component.exports